import React, { useEffect, useRef } from 'react';

import { Controller } from 'react-hook-form';
import { Checkbox } from 'primereact/checkbox';

import LabelName from 'components/UI/LabelName/LabelName';

function EventAllDay({ control, resetField, selectedcase, watch, setValue, editEventModal }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12"></div>
      <div className="col-md-8 col-12">
        <Controller
          name="all_day"
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <Checkbox
              id={field.name}
              value={field.value}
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
              // disabled={editEventModal}
            />
          )}
        />
        <LabelName required={false} htmlFor="not_linked_to_case" className="ms-2">
          All Day
        </LabelName>
      </div>
    </div>
  );
}

export default EventAllDay;
